import React from 'react';
import { convertHttps } from '../../../utils/helper';

const LenskartPromise = props => {
  const {
    redisCommonData: { LENSKART_PROMISE, LENSKART_PROMISE_ICONS },
    type,
    localeInfo,
  } = props;

  const data = JSON.parse(LENSKART_PROMISE_ICONS);
  let conditionalData = [];
  JSON.parse(LENSKART_PROMISE).forEach((flag, index) => {
    if (flag) {
      conditionalData.push(data[index]);
    }
  });
  if (props.data && props.data.length) {
    conditionalData = props.data;
  }
  return (
    <div className="display-flex justify-space-around bg-color_white">
      {conditionalData.map((item, index) => {
        const last = index === conditionalData.length - 1;
        if (type === 'Contact Lens' && localeInfo?.countryCode === 'sg' && item.text1 === '1 Year')
          return null;
        return (
          <React.Fragment key={index}>
            <div className="text-center text-color_dark_grey fsp11 lh-14">
              <span className="block mr-b10" style={{ height: '30px' }}>
                <img
                  alt={`${item.text1} ${item.text2} ${item.text3}`}
                  src={convertHttps(item.icon)}
                  style={{ height: '29px' }}
                />
              </span>
              <span className="block">{item.text1}</span>
              <span className="block">{item.text2}</span>
              <span className="block">{item.text3}</span>
            </div>
            {!last && <div className="hor-separator"></div>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LenskartPromise;
